import { render, staticRenderFns } from "./UserTabPlanningEntries.vue?vue&type=template&id=019cd41c&scoped=true&"
import script from "./UserTabPlanningEntries.vue?vue&type=script&lang=ts&"
export * from "./UserTabPlanningEntries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019cd41c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
